<template>
    <b-form-group :label="label">
        <select-with-avatar
            id="select-key-result"
            :options="keyResultOptions"
            :selected.sync="value"
            :close-on-select="true"
            :internal-search="false"
            :loading="loading"
            :no-elements-found="noElementsFound"
            :placeholder="$t('form.placeholder.select')"
            @changeSearch="debouncedSearchHandler"
            @changeValue="$emit('update:value', $event)"
            :hideSelected="false"
            :reset-after="true"
        />
        <b-form-invalid-feedback id="evaluatedId">
            <slot name="validations" />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import SelectWithAvatar from '@/views/components/selects/select-with-avatar'
import { searchByKeyResultName, getActiveKeyResults, getKeyResult } from '../../api'
import { danger } from '@/lib/notification'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
    name: 'SelectKeyResult',
    components: {
        SelectWithAvatar,
    },
    props: {
        label: '',
        existentSelectedKeyResultId: null,
        noElementsFound: '',
    },
    data() {
        return {
            value: {},
            state: {},
            keyResultOptions: [],
            loading: false,
        }
    },
    created() {
        this.debouncedSearchHandler = debounce(this.searchByKeyResultName, 1000)
        this.getActiveKRs()
    },
    methods: {
        searchByKeyResultName(search) {
            if (search.trim().length != 0) {
                this.loading = true
                searchByKeyResultName(search.trim())
                    .then((response) => {
                        this.keyResultOptions = this.mapToOptions(response.data)
                        this.loading = false
                    })
                    .catch(() => {
                        this.loading = false
                        danger()
                    })
            }
        },
        getActiveKRs() {
            this.loading = true
            getActiveKeyResults(this.user.id, this.user.manager.id)
                .then((response) => {
                    const keyResults = response.data
                    this.sortByUserId(keyResults)
                    this.keyResultOptions = this.mapToOptions(keyResults)
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                    danger()
                })
        },
        mapToOptions(keyResults) {
            return keyResults.map((kr) => {
                return {
                    value: kr.id,
                    label: kr.title,
                    picture: kr.user.picture,
                    keyResult: {
                        period: kr.objective.period.name,
                        owner: kr.user.name,
                    },
                }
            })
        },
        sortByUserId(keyResults) {
            if (this.user.id < this.user.manager.id) {
                keyResults.sort((a, b) => {
                    return a.user.id - b.user.id
                })
            } else {
                keyResults.sort((a, b) => {
                    return b.user.id - a.user.id
                })
            }
        },
        reset() {
            this.value = []
        },
    },
    computed: {
        ...mapState('profile', {
            user: (state) => state.user,
        }),
    },
    watch: {
        value() {
            this.$emit('updateValue', this.value)
        },
        existentSelectedKeyResultId(val) {
            if (val) {
                this.loading = true
                getKeyResult(val)
                    .then((response) => {
                        let keyResult = []
                        keyResult.push(response.data)
                        this.sortByUserId(keyResult)
                        keyResult = this.mapToOptions(keyResult)
                        this.value = keyResult[0]
                        this.$emit('updateValue', this.value)
                    })
                    .catch(() => {
                        this.loading = false
                        danger()
                    })
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
